import { render, staticRenderFns } from "./EditarProcedimentoOrigemLicitacaoOutraUg.vue?vue&type=template&id=4dae438d&scoped=true"
import script from "./EditarProcedimentoOrigemLicitacaoOutraUg.vue?vue&type=script&lang=ts"
export * from "./EditarProcedimentoOrigemLicitacaoOutraUg.vue?vue&type=script&lang=ts"
import style0 from "./EditarProcedimentoOrigemLicitacaoOutraUg.vue?vue&type=style&index=0&id=4dae438d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae438d",
  null
  
)

export default component.exports